"use strict";
const ResourceLoader = require("./resource-loader.js");

module.exports = class NoOpResourceLoader extends ResourceLoader {
  fetch() {
    return null;
  }
};
